<template>
    <v-expansion-panel>
        <v-expansion-panel-header hide-actions>
            <template v-slot:default="{ open }">
                <div class="d-flex align-center">
                    <div class="text-subtitle-1 font-weight-bold">Действия по акту</div>
                    <v-icon v-if="open">arrow_drop_up</v-icon>
                    <v-icon v-if="!open">arrow_drop_down</v-icon>
                </div>
            </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
            <ActActionsTable :abonentDebt="abonentDebt" :is-contract="isContract" :items="infoCreate['serv']" />
            <v-row>
                <v-spacer />
                <v-col cols="4">
                    <div class="gray--text">Отключение произведено</div>
                    <v-radio-group v-model="disconnectType">
                        <v-radio color="gray" v-for="(disconnectType, idx) of shutdownList" :key="idx" :value="disconnectType['record_id']">
                            <template v-slot:label>
                                <div class="gray--text">{{ disconnectType['heating_system_name'] }}</div>
                            </template>
                        </v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>
        </v-expansion-panel-content>
        <v-divider color="gray" />
    </v-expansion-panel>
</template>
<script>
import ActActionsTable from '@/components/acts/actActionsTable.vue';
import { mapGetters } from 'vuex';
import translate from '@/utils/translate.util';

export default {
    name: 'ActionsInfo',
    components: { ActActionsTable },
    props: ['infoCreate', 'abonentDebt', 'isContract'],
    data: function() {
        return {
            disconnectType: null
        };
    },
    computed: {
        ...mapGetters('refs', ['getShutdownList']),
        shutdownList() {
            return translate(this.getShutdownList, 'full', this.$i18n.locale);
        }
    }
};
</script>

<style scoped></style>
